import { ProductItem as ProductItemType, SelectedProductType } from 'types';

export const mergeArrays = (
  arr1: ProductItemType[],
  arr2: SelectedProductType[]
): ProductItemType[] =>
  arr1.map((selected) => {
    const fullItem = arr2.find((item) => item.id === selected.id);

    return { ...fullItem, ...selected };
  });
